import * as React from "react";
import { LoansView } from "@tlc/ls2pac/app/views/myAccountViews/accountActivitySubViews/LoansView";
import { AccountHolder, useAccount } from "../../Account";
import { useLanguage } from "../../Language";
import { TLCEventManager } from "../../../events/EventManager";
import { LS2PAC_CONSTANTS } from "src/main/resources/js/main/constants";
import { PrintAccountDataEvent } from "@tlc/ls2pac/app/managers/PrintAccountDataManager";
import { UpdateDigitalLoansButton } from "./UpdateDigitalLoansButton";
import { Button, Toolbar, Typography } from "@mui/material";
import PrintIcon from "@mui/icons-material/Print";

export const BorrowerLoansView: React.FC = () => {
  const { accountSummary, user, patron } = useAccount();
  const { translate } = useLanguage();
  const containerId = "borrowerLoansContainer";

  const viewRef = React.useRef<LoansView | null>(null);
  const [isViewReady, setIsViewReady] = React.useState(false);

  React.useEffect(() => {
    viewRef.current = new LoansView();
    setIsViewReady(true);
    return () => {
      if (viewRef.current) {
        viewRef.current.cleanup();
      } else {
        console.warn("Tried to call LoansView cleanup, but view is null");
      }
    };
  }, []);

  React.useEffect(() => {
    if (isViewReady && viewRef.current) {
      viewRef.current.load(
        { accountSummary, patron },
        user,
        document.getElementById(containerId),
        "loans"
      );
    }
  }, [accountSummary, user, patron, isViewReady]);

  const onClickPrintLoans = () => {
    TLCEventManager.fireEvent(PrintAccountDataEvent, {
      sections: [LS2PAC_CONSTANTS.MyAccountPrintTypes.loans],
    });
  };

  return (
    <>
      <Toolbar>
        <Typography sx={{ flex: "1 1" }}></Typography>
        <UpdateDigitalLoansButton
          patronId={patron.patronId}
          onUpdate={() => {
            AccountHolder.fetchAccountData(true);
          }}
          lastUpdated={accountSummary.digitalInformationLastUpdated}
        ></UpdateDigitalLoansButton>
        <Button onClick={onClickPrintLoans} startIcon={<PrintIcon />}>
          {translate("print")} {translate("loans")}
        </Button>
      </Toolbar>
      <div id={containerId}></div>
    </>
  );
};
